import { WrappedControlProps } from 'app/components/Controls/WrappedControlProps';
import isMobileOrTablet from 'app/shared/helpers/isMobileOrTablet';

export function useDropdownControl({ onClick }: WrappedControlProps) {
  const handleClick = () => {
    if (onClick) {
      onClick();
    }
  };

  const isMobile = isMobileOrTablet();

  return { handleClick, isMobile };
}
